export default __webpack_public_path__ + "static/media/flag-jamaica.d69154c7.svg";